import { userRoles } from '../constants/globals';

const authorizationService = {
  canAccessAdminPanel: (user) => {
    const roles = user.roles || [];
    if (
      roles.find(
        (r) =>
          r.id === userRoles.SUPER_ADMIN.value ||
          r.id === userRoles.ADMIN_EU.value ||
          r.id === userRoles.ADMIN_MDULS.value
      )
    ) {
      return true;
    }
    return false;
  },
  isActionAllowed: (actionName, userAllowedActionsList) => {
    if (userAllowedActionsList.find((a) => a === actionName)) {
      return true;
    }
    return false;
  },
};

export default authorizationService;
